function parseStoryFromNode(story) {
  story = story.node
  if (typeof story.content !== 'object') {
    story.content = JSON.parse(story.content)
  }
  return story
}

export default parseStoryFromNode
